import { render, staticRenderFns } from "./DeliveryHistory.vue?vue&type=template&id=0e02cb86&"
import script from "./DeliveryHistory.vue?vue&type=script&lang=js&"
export * from "./DeliveryHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports